import ModalComponent from '../../../components/ModalComponent';
import { Box } from '@mui/material';

interface SipVideoHistoryViewModalProps {
  isVisible: boolean;
  onClose: () => void;
  videoUrl: string;
  isVideo: boolean;
}

const SipVideoHistoryViewModal = ({
  isVisible,
  onClose,
  videoUrl,
  isVideo,
}: SipVideoHistoryViewModalProps) => {
  return (
    <ModalComponent
      onClose={onClose}
      isOpen={isVisible}
      title="Visualização da chamada"
      width={isVideo ? 800 : undefined}
      height={isVideo ? 600 : undefined}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          my: 0,
          py: 0,
        }}
      >
        <video
          src={videoUrl}
          controls
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            borderRadius: 8,
          }}
        >
          Seu navegador não suporta a tag de vídeo.
        </video>
      </Box>
    </ModalComponent>
  );
};

export default SipVideoHistoryViewModal;
